interface DesktopAuthBridge {
  clearSession?: () => Promise<void>;
}

function getDesktopAuthBridge() {
  return (
    globalThis.window as
      | (Window & {
          __ELECTRON_AUTH__?: DesktopAuthBridge;
        })
      | undefined
  )?.__ELECTRON_AUTH__;
}

export function hasDesktopAuthSessionBridge() {
  return Boolean(getDesktopAuthBridge()?.clearSession);
}

export async function clearDesktopAuthSession() {
  const bridge = getDesktopAuthBridge();
  if (!bridge?.clearSession) {
    return;
  }

  try {
    await bridge.clearSession();
  } catch {
    // Ignore bridge failures and continue local sign-out.
  }
}
